export function parseDuration(duration) {
    var parsed = parseFloat(duration);
    if (duration.match(/ms$/)) {
        return parsed;
    }
    return parsed * 1000;
}
export default parseDuration;

//# sourceMappingURL=parseDuration.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/utils/parseDuration.js
// module id = 82
// module chunks = 0